import React, { FC, useState, useEffect } from "react";
import { Helmet } from "react-helmet-async";
import Pagination from "shared/Pagination/Pagination";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import NewsArticleCard from "components/CardCategories/NewsArticleCard";
import { Link } from "react-router-dom";
import useCMSData from "api/cms/useCMSData";

export interface BlogPageProps {
  className?: string;
  data?: CardCategoryData[];
}
export interface CardCategoryData {
  name: string;
  img: string;
  Subheading?: string;
}
const ProductCategoryData: CardCategoryData[] = [
  {
    name: "MPs call for UK ban on two Chinese CCTV firms",
    img: "https://ichef.bbci.co.uk/news/1024/branded_news/8053/production/_119915823_gettyimages-1266205793.jpg",
    Subheading: "The world is an amazing place providing an incredible assortment of interesting locations across.",
  },
  {
    name: "Bullet CCTV Cameras",
    img: "https://resize.indiatvnews.com/en/resize/newbucket/400_-/2023/12/cctv-1-1701871179.jpg",
    Subheading: "The world is an amazing place providing an incredible assortment of interesting locations across.",
  },
  {
    name: "C-Mount CCTV Cameras",
    img: "https://www.sourcesecurity.com/img/news/612/nedap-adapts-to-change-the-dynamic-nature-of-retail-crime-920x533.jpg",
    Subheading: "The world is an amazing place providing .",
  },
  {
    name: "Advanced Security Solutions for Modern Businesses",
    img: "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80",
    Subheading: "Discover how modern security systems are revolutionizing business protection and monitoring capabilities.",
  },
  {
    name: "Network Infrastructure Best Practices",
    img: "https://images.unsplash.com/photo-1558494949-ef010cbdcc31?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80",
    Subheading: "Learn about the latest trends in network infrastructure and how to optimize your business connectivity.",
  },
  {
    name: "Access Control Systems: A Complete Guide",
    img: "https://images.unsplash.com/photo-1563013544-824ae1b704d3?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80",
    Subheading: "Everything you need to know about implementing effective access control systems in your organization.",
  },
  {
    name: "Fire Safety Technology Innovations",
    img: "https://images.unsplash.com/photo-1581578731548-c6a0c3f2fcc0?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80",
    Subheading: "Explore the latest innovations in fire safety technology and how they're improving building security.",
  },
  {
    name: "Smart Home Security Integration",
    img: "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80",
    Subheading: "How to integrate smart security systems into your home for maximum protection and convenience.",
  },
  {
    name: "Cybersecurity in Physical Security Systems",
    img: "https://images.unsplash.com/photo-1563013544-824ae1b704d3?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80",
    Subheading: "Understanding the importance of cybersecurity in modern physical security infrastructure.",
  },
  {
    name: "Future of Surveillance Technology",
    img: "https://images.unsplash.com/photo-1581578731548-c6a0c3f2fcc0?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80",
    Subheading: "A look into the future of surveillance technology and what to expect in the coming years.",
  },
  {
    name: "Cost-Effective Security Solutions",
    img: "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80",
    Subheading: "How to implement effective security measures without breaking the budget.",
  },
  {
    name: "Remote Monitoring Best Practices",
    img: "https://images.unsplash.com/photo-1563013544-824ae1b704d3?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80",
    Subheading: "Learn how to effectively monitor your security systems remotely for maximum efficiency.",
  },
];

const BlogPage: FC<BlogPageProps> = ({
  className = "",
  data = ProductCategoryData,
}) => {
  const [displayedPosts, setDisplayedPosts] = useState<CardCategoryData[]>([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  
  const postsPerPage = 6; // Number of posts to load each time
  
  // Fetch CMS data (if available)
  const { cmsData, isLoading: cmsLoading } = useCMSData();
  
  // Initialize displayed posts
  useEffect(() => {
    const initialPosts = data.slice(0, postsPerPage);
    setDisplayedPosts(initialPosts);
    setHasMore(data.length > postsPerPage);
  }, [data]);

  // Load more posts function
  const handleLoadMore = () => {
    if (isLoading || !hasMore) return;
    
    setIsLoading(true);
    
    // Simulate API call delay
    setTimeout(() => {
      const nextPage = currentPage + 1;
      const startIndex = nextPage * postsPerPage;
      const endIndex = startIndex + postsPerPage;
      const newPosts = data.slice(startIndex, endIndex);
      
      if (newPosts.length > 0) {
        setDisplayedPosts(prev => [...prev, ...newPosts]);
        setCurrentPage(nextPage);
        setHasMore(endIndex < data.length);
      } else {
        setHasMore(false);
      }
      
      setIsLoading(false);
    }, 1000); // 1 second delay to show loading state
  };

  return (
    <div
      className={`nc-PageCollection ${className}`}
      data-nc-id="PageCollection"
    >
      <Helmet>
        <title>Blog and News - MEET Solutions</title>
      </Helmet>

      <div className="container py-5 lg:pb-10 lg:pt-10 ">
        <div className="space-y-10 lg:space-y-14">
          {/* HEADING */}
          <div className="max-w-screen-sm">
            <h2 className="block text-2xl sm:text-3xl lg:text-4xl font-semibold">
              Blog and News
            </h2>
            <p className="mt-2 text-neutral-600 dark:text-neutral-400">
              Stay updated with the latest news and insights from MEET Solutions
            </p>
          </div>

          <hr className="border-slate-200 dark:border-slate-700" />
          <main>
            <div className="grid grid-cols-12 gap-5">
              {displayedPosts.map((item, index) => (
                <div
                  className=" col-span-12  sm:col-span-6  md:col-span-6 lg:col-span-4"
                  key={`${item.name}-${index}`}
                >
                  <Link to={"/blog-single"}>
                    <NewsArticleCard
                      featuredImage={item.img}
                      name={item.name}
                      Subheading={item.Subheading}
                    />
                  </Link>
                </div>
              ))}
            </div>

            {/* Show loading state when fetching more posts */}
            {isLoading && (
              <div className="flex justify-center mt-8">
                <div className="flex items-center space-x-2 text-neutral-600 dark:text-neutral-400">
                  <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-primary-600"></div>
                  <span>Loading more posts...</span>
                </div>
              </div>
            )}

            {/* Load More Button */}
            <div className="flex flex-col mt-12 lg:mt-16 space-y-5 sm:space-y-0 sm:space-x-3 sm:flex-row sm:justify-between sm:items-center">
              <Pagination />
              {hasMore ? (
                <ButtonPrimary 
                  onClick={handleLoadMore}
                  disabled={isLoading}
                  loading={isLoading}
                >
                  {isLoading ? "Loading..." : "Show me more"}
                </ButtonPrimary>
              ) : (
                <div className="text-center text-neutral-500 dark:text-neutral-400">
                  <p>You've reached the end of our blog posts!</p>
                </div>
              )}
            </div>
          </main>
        </div>
      </div>
    </div>
  );
};

export default BlogPage;
